import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Carlos M.', 'Ana G.', 'David R.', 'Laura S.', 'Javier P.', 'María T.', 'Alejandro L.', 'Carmen F.', 'Daniel C.', 'Elena B.', 'Sergio N.', 'Lucía V.', 'Pablo M.', 'Marta D.', 'Jorge R.'];
const cities = ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Málaga', 'Murcia', 'Palma', 'Las Palmas', 'Bilbao', 'Alicante', 'Córdoba', 'Valladolid', 'Vigo', 'Gijón'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
      // Then set interval for subsequent popups (random between 15s and 25s)
      const intervalId = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 10000) + 15000);
      return () => clearInterval(intervalId);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-271">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -50
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -50
    }} transition={{
      duration: 0.5,
      type: 'spring',
      stiffness: 100
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-full bg-gray-900 border-l-4 border-neon rounded-r-lg shadow-2xl p-4 flex items-center gap-4" data-id="element-272">
          <div className="bg-neon/20 p-2 rounded-full shrink-0" data-id="element-273">
            <CheckCircle2 className="w-6 h-6 text-neon" data-id="element-274" />
          </div>
          <div data-id="element-275">
            <p className="text-white text-sm font-medium" data-id="element-276">
              <span className="font-bold text-neon" data-id="element-277">
                {currentPurchase.name}
              </span>{' '}
              de {currentPurchase.city}
            </p>
            <p className="text-gray-400 text-xs mt-1" data-id="element-278">
              acaba de comprar El Método 500€
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}